import { useState } from "react";
import { VaultIcon, WrenchIcon } from "lucide-react";

import { cn } from "../../lib/utils";
import { MorrowAgentOrb } from "../brand/MorrowAgentOrb";
import { resolveMorrowStepIcon } from "./morrowStepIcon";

export function MorrowStepContextIcon({
  text,
  toolName,
  preferOrb = false,
  className,
}: {
  readonly text?: string | undefined;
  readonly toolName?: string | undefined;
  readonly preferOrb?: boolean;
  readonly className?: string | undefined;
}) {
  const resolved = resolveMorrowStepIcon({ text, toolName, preferOrb });
  const [logoFailed, setLogoFailed] = useState(false);

  if (resolved.kind === "logo" && resolved.logoUrl && !logoFailed) {
    return (
      <img
        src={resolved.logoUrl}
        alt=""
        aria-hidden
        className={cn("size-3 shrink-0 rounded-[2px] object-contain", className)}
        onError={() => setLogoFailed(true)}
      />
    );
  }

  if (resolved.kind === "logo" && logoFailed) {
    if (preferOrb) {
      return <MorrowAgentOrb className={cn("size-3 shrink-0", className)} />;
    }
    return (
      <WrenchIcon
        aria-hidden
        className={cn("size-3 shrink-0 text-muted-foreground/60", className)}
      />
    );
  }

  if (resolved.kind === "vault") {
    return (
      <VaultIcon
        aria-hidden
        className={cn("size-3 shrink-0 text-muted-foreground/60", className)}
      />
    );
  }

  if (resolved.kind === "file" && resolved.FileIcon) {
    const FileIcon = resolved.FileIcon;
    return (
      <FileIcon aria-hidden className={cn("size-3 shrink-0 text-muted-foreground/60", className)} />
    );
  }

  if (resolved.kind === "lucide" && resolved.LucideIcon) {
    const StepIcon = resolved.LucideIcon;
    return (
      <StepIcon aria-hidden className={cn("size-3 shrink-0 text-muted-foreground/60", className)} />
    );
  }

  if (resolved.kind === "orb") {
    return <MorrowAgentOrb className={cn("size-3 shrink-0", className)} />;
  }

  return (
    <WrenchIcon aria-hidden className={cn("size-3 shrink-0 text-muted-foreground/60", className)} />
  );
}
